import React from 'react';
import style from './style.module.scss';
import {IProductSnippet} from 'shared/types/productSnippet.types';
import {formatRating} from 'core/helpers';
import {Tooltip} from 'components/Tooltip';
import {Typography} from 'components/Typography';

type TExpertRatingProps = IProductSnippet['ratings'][0];

export const ExpertRating = (props: TExpertRatingProps) => {
    const {code, title, value} = props;

    if (code.toLowerCase() === title.toLowerCase()) {
        return (
            <div key={code} className={style.root}>
                <Typography variant={'label-10-r'}>{code}</Typography>
                <Typography variant={'label-10-r'}>{formatRating(value)}</Typography>
            </div>
        );
    }

    return (
        <Tooltip
            key={code}
            childrenClassName={style.tooltip}
            overlay={
                <Typography className={style.overlay} variant={'label-12-r'}>
                    {title}
                </Typography>
            }
            place={'bottom'}
        >
            <div key={code} className={style.root}>
                <Typography variant={'label-10-r'}>{code}</Typography>
                <Typography variant={'label-10-r'}>{formatRating(value)}</Typography>
            </div>
        </Tooltip>
    );
};
